import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment'
import 'moment/locale/es'
import 'moment/locale/en-gb'

import { LangSession } from '@/services/session'
import Config from '@/config'
import messages from './locales'

Vue.use(VueI18n)

const sessionLocale = LangSession.get()
const defaultLocale = sessionLocale || Config.i18n.locale
moment.locale(Config.i18n.moment[defaultLocale])

const i18n = new VueI18n({
    locale: defaultLocale,
    fallbackLocale: Config.i18n.fallbackLocale,
    messages,
})

export const changeLocale = (locale) => {
    if (Config.i18n.locales.includes(locale)) {
        i18n.locale = locale
        moment.locale(Config.i18n.moment[locale])
        LangSession.set(locale)
    } else {
        // eslint-disable-next-line no-console
        console.warn(`'${locale}' locale is not available.`)
    }
}

export default i18n
